import styles from "./NavBar.module.css";
import NavMenu from "./menus/NavMenu";
import React, { useReducer } from "react";
import { ACTIONS, initialState, reducer } from "./navBarReducer";
import MetroNet from "../labels/MetroNet";

const NavBar = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const closeMenus = () => {
    dispatch({ type: ACTIONS.MENU_CLOSE });
  };

  return (
    <div className={styles.navDivContainer}>
      <div className={styles.logoText}>
        <MetroNet fontSizeOverride={"24px"} />
      </div>

      {/* <img className={styles.logo} alt="" src={logo} /> */}
      <div className={styles.navDiv}>
        <NavMenu
          ACTIONS={ACTIONS}
          dispatch={dispatch}
          state={state}
          closeMenus={closeMenus}
        />
      </div>
      <img
        className={styles.menuIcon}
        alt=""
        src={state.mobileMenuIcon}
        onClick={() =>
          dispatch({
            type: ACTIONS.MENU_TOGGLE,
            value: !state.mobileMenuOpen,
          })
        }
      />
    </div>
  );
};

export default NavBar;
